import * as z from "zod";

export const LanguageIsoCodeEnum = {
    Spanish: "es",
    English: "en",
    French: "fr",
} as const;
export type LanguageIsoCodeEnum =
    (typeof LanguageIsoCodeEnum)[keyof typeof LanguageIsoCodeEnum];
export const LanguageIsoCodeEnumSchema = z.enum(LanguageIsoCodeEnum);

export const isLanguageIsoCode = (
    value: unknown,
): value is LanguageIsoCodeEnum => LanguageIsoCodeEnumSchema.validate(value);

/**
 * Narrows a language tag to a supported ISO code: a region tag (`es-ES`)
 * resolves to its primary subtag, anything unsupported to `fallback`.
 */
export const toLanguageIsoCode = (
    languageTag: string,
    fallback: LanguageIsoCodeEnum,
): LanguageIsoCodeEnum => {
    const [primarySubtag] = languageTag.split("-");

    return isLanguageIsoCode(primarySubtag) ? primarySubtag : fallback;
};

export const LanguageSchema = z
    .object({
        isoCode: LanguageIsoCodeEnumSchema.readonly(),
        label: z.string().trim(),
    })
    .brand<"Language">();

export type LanguageInputProps = z.input<typeof LanguageSchema>;
export type Language = z.output<typeof LanguageSchema>;

export const LanguageIsoCodeSchema = z
    .object({
        isoCode: LanguageIsoCodeEnumSchema,
    })
    .brand<"LanguageIsoCode">();

export type LanguageIsoCodeInputProps = z.input<typeof LanguageIsoCodeSchema>;
export type LanguageIsoCode = z.output<typeof LanguageIsoCodeSchema>;
